import { Container, Text, Sprite, Graphics } from "pixi.js";
import { ISocialsThemeRendererProps } from "./ISocialsThemeRenderer";

export const renderTheme2 = ({
  container,
  destination,
  integrations,
  widget,
  icons,
  scaleFactor,
}: ISocialsThemeRendererProps) => {
  const options = widget.options;
  const itemsContainer = new Container();

  let currentX = 0;
  const gap = 32 * scaleFactor;

  integrations.forEach((data) => {
    const item = new Container();

    // Icon
    const iconTexture = icons[data.platform];
    const iconSize =
      (options.fontSize === "xs"
        ? 20
        : options.fontSize === "sm"
          ? 24
          : options.fontSize === "md"
            ? 28
            : options.fontSize === "lg"
              ? 32
              : 36) * scaleFactor;

    let iconHeight = 0;

    if (iconTexture) {
      const icon = new Sprite(iconTexture);
      icon.width = iconSize;
      icon.height = iconSize;
      icon.anchor.set(0.5, 0); // Center X, Top Y
      icon.x = 0; // Centered
      // icon.tint = data.color; // REMOVED
      item.addChild(icon);
      iconHeight = iconSize;
    }

    // Text
    const textStyle = {
      fontFamily: options.fontFamily || "Roboto",
      fontSize:
        (options.fontSize === "xs"
          ? 14
          : options.fontSize === "sm"
            ? 16
            : options.fontSize === "md"
              ? 18
              : options.fontSize === "lg"
                ? 20
                : 22) * scaleFactor,
      fill: options.textColor,
      fontWeight: options.bold ? "bold" : "normal",
      fontStyle: options.italic ? "italic" : "normal",
      align: "center",
      letterSpacing: options.wordSpacing,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any;

    const displayName = data.user?.displayName || `@${data.platform}`;
    const text = new Text({ text: displayName, style: textStyle });

    text.anchor.set(0.5, 0);
    text.x = 0;
    text.y = iconHeight + 12 * scaleFactor; // Gap below icon

    item.addChild(text);

    if (options.underline) {
      const underline = new Graphics();
      underline.moveTo(0, 0);
      underline.lineTo(text.width, 0);
      underline.stroke({ width: 2 * scaleFactor, color: options.textColor });
      underline.x = text.x - text.width / 2;
      underline.y = text.y + text.height;
      item.addChild(underline);
    }

    if (options.strike) {
      const strike = new Graphics();
      strike.moveTo(0, 0);
      strike.lineTo(text.width, 0);
      strike.stroke({ width: 2 * scaleFactor, color: options.textColor });
      strike.x = text.x - text.width / 2;
      strike.y = text.y + text.height / 2;
      item.addChild(strike);
    }

    // Reposition item in row
    // Since item is centered at x=0, we need to shift it
    // But width/bounds might be tricky with centered children.
    // Let's use getLocalBounds

    // Simplification: We just place them at currentX + halfWidth

    item.x = currentX + Math.max(iconSize, text.width) / 2;
    itemsContainer.addChild(item);

    currentX += Math.max(iconSize, text.width) + gap;
  });

  itemsContainer.x = (destination.width - itemsContainer.width) / 2;
  itemsContainer.y = (destination.height - itemsContainer.height) / 2;

  container.addChild(itemsContainer);
};
